import React from 'react';

import './index.scss';

// eslint-disable-next-line react/prop-types
export default function SubtitleSemiBold({ children }) {
  return (
    <div className="subtitle-semi-bold">{ children }</div>
  );
}
